import React, { useRef } from 'react';
import BottomNavigation from './BottomNavigation/BottomNavigation';
import { useMeasureToCssVar } from '../hooks/useMeasureToCssVar';
import './Layout.css';

const Layout = ({ children }) => {
  const bottomNavRef = useRef(null);

  // Measure bottom navigation height so content clears it
  useMeasureToCssVar(bottomNavRef, '--bottom-nav-height');

  return (
    <div className="layout">
      <main className="main-content">{children}</main>
      <BottomNavigation ref={bottomNavRef} />
    </div>
  );
};

export default Layout;
